import React from 'react';
import ScreenSection from '../screen-section/ScreenSection';
import SectionTitle from '../section-title/SectionTitle';
import ContentContainer from '../content-container/ContentContainer';
import ContactsForm from '../contacts-form/ContactsForm';
import mapWhiteImage from '../../assets/images/map-white.svg';

import styles from './ContactsScreen.module.scss';

const ContactsScreen = ({ id }) => (
  <ScreenSection
    id={id}
    theme="light"
    background={mapWhiteImage}
    style={{
      backgroundImage: 'radial-gradient(circle at 50% 1%, #ffffff, #e3e3e3)',
    }}
    noLimit
  >
    <ContentContainer width="narrow">
      <div className={styles.root}>
        <div className={styles.titleCol}>
          <SectionTitle>Contacts</SectionTitle>
        </div>

        <div className={styles.contentCol}>
          <ContactsForm />
        </div>
      </div>
    </ContentContainer>
  </ScreenSection>
);

export default ContactsScreen;
